import React from 'react';
import { Layout } from 'tea-component';
import Tabs from '@intelligence/components/NewIconTabs';
const { Content } = Layout;
import { connect } from 'umi';
import './index.scss';
import { DBI_TOPCHARTS } from '@/pages/intelligence/models/topcharts';

function HeaderDetails(props: any) {
  //  activeId 选中的tab
  //  tabList tab数据
  //  change tab选中事件
  //  title  标题
  //   children 前边自定义内容
  //   operation 右边自定义内容
  let { activeId, tabList, change, title, children, className, operation, goBackHandle, newMarkIdsMappingKey,
    entityType,
  } = props;

  return (
    <Content.Header
      showBackButton
      onBackButtonClick={() => {
        if (goBackHandle) {
          goBackHandle();
        } else {
          window.history.back();
        }
      }}
      title={title}
      operation={operation}
      // contentHead-normal 是定位 tab
      className={`${className ? className : ''
        } details-header contentHead-normal`}
    >
      {children}
      {entityType === 'company' && <div className="header-tab">
        <Tabs
          ceiling
          className="dbi-user-guide__game-details-tabs"
          newMarkIdsMappingKey={newMarkIdsMappingKey}
          tabs={tabList}
          animated={false}
          activeId={activeId}
          onActive={(tab) => {
            change(tab);
          }}
        />
      </div>}
    </Content.Header>
  );
}

export default connect((state: any) => {
  return {
    topchartsState: state[DBI_TOPCHARTS],
  };
})(HeaderDetails);